<div *ngIf="transactionMode === 'CHEQUE';then  cheque  else pos"></div>
<ng-template #cheque>

  <div class="modal-header">
    <h5 class="modal-title" style="font-size: 16px;">
      <span class="fw-semi-bold">Cheque Details</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)">
      
    </button>
  </div>
  <div class="modal-body"> 
      <form role="form" [formGroup]="transactionForm">
    <div class="col-sm-12">
      <div class="mb-3 row">
        <div class="col-3">
          <label class="text-muted">bank</label>
        </div>
     
        <div class="col-9" [ngClass]="{ 'has-danger' : (submitted && transactionForm.get('bank').invalid) }">
          <select class="form-control form-control-sm" formControlName="bank" required>
            <!--<option value="">Choose bank</option>-->
            <option value="{{bank.id}}" *ngFor="let bank of allBankList">{{bank.name}}-{{bank.accNum}}</option>
          </select>
          <small class="text-danger" *ngIf="submitted && transactionForm.get('bank').hasError('required')">
            {{'Bank'|translate}} {{'is required'|translate}}
          </small>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="mb-3 row">
        <div class="col-3">
          <label class="text-muted">Cheque</label>
        </div>
        <div class="col-9" [ngClass]="{ 'has-danger' : (submitted && transactionForm.get('chequeNumber').invalid) }">
          <input #chequeField type="text" maxlength="15" (keydown.space)="$event.preventDefault()" class="form-control form-control-sm" formControlName="chequeNumber" required>
          <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('required')">
           {{ 'CHEQUE'|translate}} {{'number'|translate}} {{'is required'|translate}}
          </small>
          <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('pattern')">
            {{ 'CHEQUE'|translate}} {{'number'|translate}} {{'must be digits or letters'|translate}}
           </small>
           <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('minlength')">
            {{ 'CHEQUE'|translate}} {{'number'|translate}} {{'must be at least 4 characters long'|translate}}
           </small>
           <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('maxlength')">
            {{ 'CHEQUE'|translate}} {{'number'|translate}} {{'cannot exceed 15 characters'|translate}}
           </small>
        </div>
      </div>
    </div>
    <div class="form-check d-flex" (click)="changeChequeClearance($event)">
        <input class="form-check-input float-end me-2" type="checkbox" id="same_address" [checked]="chequeCleared===true" (click)="$event.stopPropagation()">
        <label class="form-check-label" for="same_address">{{'cheque cleared? ' |translate}} </label>
      </div>
  </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm" aria-label="Close" (click)="activeModal.close(false)">{{'Cancel'|translate}}</button>
    <button type="button" class="btn btn-success btn-sm" aria-label="Confirm" (click)="addDetails()">Submit</button>
  </div>
  

</ng-template>




<ng-template #pos>

  <div class="modal-header">
    <h5 class="modal-title" style="font-size: 16px;">
      <span class="fw-semi-bold" *ngIf="transactionMode=='POS'">CARD Details</span>
      <span class="fw-semi-bold" *ngIf="transactionMode=='QRCODE'">QRPay Details</span>
      <span class="fw-semi-bold" *ngIf="transactionMode=='NETBANKING'">Bank Transfer Details</span>
      <span class="fw-semi-bold" *ngIf="transactionMode=='MO'">Money Order Details</span>
      <span class="fw-semi-bold" *ngIf="transactionMode=='ONLINE'">Online Details</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)">
      
    </button>
  </div>
  <div class="modal-body"> 
      <form role="form" [formGroup]="transactionForm">
    <div class="col-sm-12" *ngIf="transactionMode !== 'MO'">
      <div class="mb-3 row">
        <div class="col-3">
          <label class="text-muted">bank</label>
        </div>
     
        <div class="col-9" [ngClass]="{ 'has-danger' : (submitted && transactionForm.get('bank').invalid) }">
          <select class="form-control form-control-sm" formControlName="bank" required>
            <option value="">Choose bank</option>
            <option value="{{bank.id}}" *ngFor="let bank of allBankList">{{bank.name}}-{{bank.accNum}}</option>
          </select>
          <small class="text-danger" *ngIf="submitted && transactionForm.get('bank').hasError('required')">
            {{'Bank'|translate}} {{'is required'|translate}}
          </small>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="mb-3 row">
        <div class="col-3">
          <label class="text-muted">Transaction No</label>
        </div>
        <div class="col-9" [ngClass]="{ 'has-danger' : (submitted && transactionForm.get('chequeNumber').invalid) }">
          <input #chequeField type="text" maxlength="15" (keydown.space)="$event.preventDefault()" class="form-control form-control-sm" formControlName="chequeNumber" required>
          <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('required')">
           {{ 'Transaction'|translate}} {{'number'|translate}} {{'is required'|translate}}
          </small>
          <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('pattern')">
            {{ 'Transaction'|translate}} {{'number'|translate}} {{'must be digits or letters'|translate}}
           </small>
           <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('minlength')">
            {{ 'Transaction'|translate}} {{'number'|translate}} {{'must be at least 4 characters long'|translate}}
           </small>
           <small class="text-danger" *ngIf="submitted && transactionForm.get('chequeNumber').hasError('maxlength')">
            {{ 'Transaction'|translate}} {{'number'|translate}} {{'cannot exceed 15 characters'|translate}}
           </small>
        </div>
      </div>
    </div>
    <ng-container  *ngIf="transactionMode=='POS'"> 
      <div class="col-sm-12">
      <div class="mb-3 row">
        <div class="col-3">
          <label class="text-muted">CARD Charge (%)</label>
        </div>
        <div class="col-9">
          
          <input type="text" class="form-control form-control-sm" formControlName="posCharge" disabled>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="mb-3 row">
        <div class="col-3">
          <label class="text-muted">Amount</label>
        </div>
        <div class="col-9">
         
          <label class="text-muted">{{totalAmount|number: '1.2-2'}}</label>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="mb-3 row">
        <div class="col-3">
          <label class="text-muted">Swiping Amount</label>
        </div>
        <div class="col-9">
         
          <label class="text-muted">{{roundOff(totalSwipingAmount)|number: '1.2-2'}}</label>
        </div>
      </div>
    </div>
  </ng-container>

  </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm" aria-label="Close" (click)="activeModal.close(false)">{{'Cancel'|translate}}</button>
    <button type="button" class="btn btn-success btn-sm" aria-label="Confirm" (click)="addDetails()">Submit</button>
  </div>
  

</ng-template>
